import React, { useMemo } from 'react'

import { P } from '../../../../style/Typography.style'

import InterviewScorecard from './InterviewScorecard'
import EmptyWrapper from '../../../EmptyWrapper'

import Flex from '../../../layouts/Flex'

const ApplicantScorecardSection = ({
  interviews,
  totalWeightedScore,
  overallRating,
}) => {
  const columns = useMemo(
    () => [
      {
        Header: 'Criteria',
        accessor: 'criteria',
      },
      {
        Header: 'Guide Question(s)',
        accessor: 'guide_questions',
        Cell: ({ value }) => (
          <div dangerouslySetInnerHTML={{ __html: value }} />
        ),
        width: 10000,
      },
      {
        Header: 'Notes',
        accessor: 'notes',
        width: 10000,
        Cell: ({ value }) => (
          <div dangerouslySetInnerHTML={{ __html: value }} />
        ),
      },
      {
        Header: 'Score',
        accessor: 'score',
      },
    ],
    []
  )

  return (
    <>
      <P
        textTransform="uppercase"
        marginTop="2rem"
        marginBottom="1rem"
        weight="500"
        size=".875rem"
      >
        Applicant Scorecard
      </P>
      {interviews?.length > 0 ? (
        <>
          {interviews.map((item, index) => (
            <InterviewScorecard
              key={index}
              title={item.stage || ''}
              data={item.results || []}
              score={item.rawScore || 0}
              rating={item.rating}
              columns={columns}
            />
          ))}

          <Flex justify="flex-end" gap="2rem" margin="1rem 0 0 0">
            <Flex direction="column" gap="0.25rem">
              <P textAlign="right" weight="400" size=".875rem" minWidth="100px">
                Total Weighted Score:
              </P>
              <P textAlign="right" weight="400" size=".875rem" minWidth="100px">
                Overall Rating:
              </P>
            </Flex>
            <Flex items="flex-end" direction="column" gap="0.25rem">
              <P textAlign="right" weight="400" size=".875rem" minWidth="100px">
                {totalWeightedScore}
              </P>
              <P textAlign="right" weight="400" size=".875rem" minWidth="100px">
                {overallRating}
              </P>
            </Flex>
          </Flex>
        </>
      ) : (
        <EmptyWrapper message="Applicant has not been assessed yet." />
      )}
    </>
  )
}

export default ApplicantScorecardSection
